module.exports = __webpack_public_path__ + "img/rec_1.11d20d94.png";